import { DialogContent, Theme, styled } from '@material-ui/core';

export const FooterWrapper = styled('footer')<Theme>(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  padding: theme.spacing(1, 2),
  fontSize: theme.typography.h4.fontSize,
  background: theme.config.appbarColors.background,
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
}));

export const InfoLine = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(0.5, 0),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledDialogContent = styled(DialogContent)<Theme>(({ theme }) => ({
  paddingBottom: theme.spacing(3),
}));
